import React from 'react';
import { observer, inject } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { Grid, withStyles, Button, FormControl, TextField } from '@material-ui/core';
import Loader from '../../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';
import CustomFooter from '../../../components/Table/CustomFooter';

class RoomsBedsManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      groupName: '',
      subGroupName: '',
      data: {},
      moduleId: null,
      queryOption: {
        offset: 0,
        limit: 15,
      },
    };
  }

  async componentDidMount() {
    const modulePath = this.props.location.pathname.replace('/app/modules/', '');
    const moduleId = Number(modulePath.replace('/manage', ''));
    this.setState({ moduleId });

    await this.initData(moduleId);
    await this.getBeds(moduleId);
  }

  async getBeds(moduleId) {
    const { offset, limit, search, sort, order, action } = this.props.bed.toJS();
    if (action) {
      let queryOption = {};
      queryOption.offset = offset;
      queryOption.limit = limit;
      queryOption.search = search;
      queryOption.sort = sort;
      queryOption.order = order;
      await this.props.bed.getBedsList(moduleId, queryOption);
      this.props.bed.setAction('action', null);
    } else {
      this.props.bed.resetData();
      await this.props.bed.getBedsList(moduleId, this.state.queryOption);
    }
  }

  async initData(moduleId) {
    const subGroup = await this.props.subGroup.getSubgroupById(moduleId);
    if (subGroup) {
      // const group = await this.props.group.getGroupById(subGroup.groupId);
      this.setState({
        subGroupName: subGroup.name,
        // groupName: group ? group.name : "-",
      });
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    const modulePath = this.props.location.pathname.replace('/app/modules/', '');
    const moduleId = Number(modulePath.replace('/manage', ''));

    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_room_bed')}`,
      showCancelButton: true,
      confirmButtonText: `${t('delete')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.bed.deleteBed(id, moduleId);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('delete_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.bed.getBedsList(moduleId, this.state.queryOption);
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_delete')}`,
                  type: 'error',
                });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  unassign(id) {
    const { t } = this.props;
    const modulePath = this.props.location.pathname.replace('/app/modules/', '');
    const moduleId = Number(modulePath.replace('/manage', ''));
    const { bedsList } = this.props.bed.toJS();
    const getData = bedsList.data.find((item) => item.id === id);
    if (getData) {
      this.setState({
        data: {
          id: getData.id,
          patientId: getData.patientId,
        },
      });
    }
    Swal.fire({
      html: `<h4>${t('unassign_patient_from_room_bed')}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('unassign')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.bed.discharge(this.state.data);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('unassign_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.bed.getBedsList(moduleId, this.state.queryOption);
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_unassign')}`,
                  type: 'error',
                });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_unassign')}`,
              type: 'error',
            });
          }
        }
      }
    });
  }

  createRoomBed() {
    const { classes, t } = this.props;
    const { id } = this.props.match.params;
    return (
      <Link to={`/app/modules/${id}/manage/create`} title='Create'>
        <Button variant='outlined' color='primary' className={classes.button}>
          <Icons.Add />
          {t('create_room_bed')}
        </Button>
      </Link>
      // <Grid container spacing={16}>
      //   <Grid style={{marginRight: '20px', marginTop: '12px', marginLeft: '12px'}} >
      //     <Typography
      //       variant="subtitle1"
      //       className={classes.fontTitle + " " + classes.labelHeader}
      //     >
      //     {config.configType ? t("group") : t("module_name")} : {this.state.subGroupName}
      //     </Typography>
      //   </Grid>
      //   <Link to={`/app/modules/${id}/manage/create`} title="Create">
      //     <Button variant="outlined" color="primary" className={classes.button}>
      //       <Icons.Add />
      //       {t("create_room_bed")}
      //     </Button>
      //   </Link>
      // </Grid>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.bed.toJS();
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.bed.setData('offset', 0, false);
    this.props.bed.setData('search', value);
  };

  handleChangeRowsPerPage = (value) => {
    this.props.bed.setData('limit', value, true, this.state.moduleId);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.bed.toJS();
    this.props.bed.setData('offset', value * limit, true, this.state.moduleId);
  };

  render() {
    const { classes, t } = this.props;
    const { bedsList, loading, limit, search, sort, order } = this.props.bed.toJS();
    // const group = this.props.group.toJS();
    const subGroup = this.props.subGroup.toJS();
    const page = bedsList.data ? bedsList.pagination.page - 1 : 0;
    const count = bedsList.data ? bedsList.pagination.count : 0;

    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'roomName',
        label: `${t('room_name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'roomName' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[1]}</div>;
          },
        },
      },
      {
        name: 'name',
        label: `${t('bed_name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[2]}</div>;
          },
        },
      },
      {
        name: 'patientId',
        label: `${t('patient_id')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            const { id } = this.props.match.params;
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/modules/${id}/bed/${row ? row[0] : ''}/view`} title={t('view')}>
                  {' '}
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/modules/${id}/bed/${row ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  id={`unassign-${row ? row[0] : ''}`}
                  disabled={row && row[3] ? false : true}
                  title={t('unassign')}
                  onClick={() => this.unassign(row ? row[0] : '')}
                >
                  <Icons.LinkOff color={row && row[3] ? 'primary' : 'disabled'} />
                </IconButton>
                <IconButton
                  id={`delete-${row ? row[0] : ''}`}
                  disabled={row && row[3] ? true : false}
                  title={t('delete')}
                  onClick={() => this.deleteItem(row ? row[0] : '')}
                >
                  <Icons.Delete color={row && row[3] ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];
    return (
      <React.Fragment>
        <Loader loading={loading || subGroup.loading} />
        <PageTitle title={`${t('manage_room_bed')} ${this.state.subGroupName}`} button={this.createRoomBed()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item xs={12}>
            <MUIDataTable
              data={bedsList.data}
              columns={columns}
              options={{
                count: bedsList.data ? bedsList.pagination.count : 0,
                page: bedsList.data ? bedsList.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  switch (action) {
                    case 'changePage':
                      this.props.bed.setData(
                        'offset',
                        tableState.page * tableState.rowsPerPage,
                        true,
                        this.state.moduleId,
                      );
                      break;
                    case 'changeRowsPerPage':
                      this.props.bed.setData('limit', tableState.rowsPerPage, true, this.state.moduleId);
                      break;
                    case 'search':
                      this.props.bed.setData('offset', 0, false);
                      this.props.bed.setData('search', tableState.searchText, true, this.state.moduleId);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.bed.setData('offset', 0, false);
                      this.props.bed.setData('sort', sortList[4], false);
                      this.props.bed.setData(
                        'order',
                        sortList[6] === 'descending' ? 'desc' : 'asc',
                        true,
                        this.state.moduleId,
                      );
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  labelHeader: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  button: {
    // marginTop: theme.spacing.unit,
    // marginBottom: theme.spacing.unit * 2,
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  fontTitle: {
    fontWeight: 'bold',
  },
  actionBox: {
    minWidth: '250px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('subGroup', 'bed', 'group')(observer(RoomsBedsManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
